/**
 * R24 · Marktplatz-Streifen: ans Seitenende setzen, sanfter Lauf
 *
 * Ausgelagert aus snippets/r24-pdp-marketplaces.liquid (perf/pdp-weight, 23.09.2026): vorher inline und
 * parserblockierend in jeder Seite, jetzt gecacht und `defer` (laeuft nach dem
 * Parsen, vor DOMContentLoaded). Kein Liquid in dieser Datei.
 */
(function () {
  /* Owner-Vorgabe: der Marktplatz-Streifen ist die LETZTE Reihe der Seite —
     direkt vor dem Footer, nach allen Produkt-/Empfehlungs-Bändern.
     Produktseite (Runde 3): als ERSTE Reihe unter dem Kaufbereich — direkt nach der
     Hauptsektion ([data-r24pd]), nie in einem aufklappbaren Bereich. */
  function place() {
    var b = document.querySelector('[data-r24-mp]');
    if (!b || b.getAttribute('data-placed') === '1') return;
    var pd = document.querySelector('[data-r24pd]');
    var sec = pd && pd.closest('[id^="shopify-section"]');
    var nach = sec || pd;
    if (nach && nach.parentNode) {
      nach.parentNode.insertBefore(b, nach.nextSibling);
      b.removeAttribute('hidden');
      b.setAttribute('data-placed', '1');
      return;
    }
    var secs = document.querySelectorAll('[id^="shopify-section"]');
    var footer = null;
    for (var i = 0; i < secs.length; i++) {
      var id = secs[i].id || '';
      if (id.indexOf('footer') > -1) { footer = secs[i]; break; }
    }
    /* Produktvorlage ohne Kaufbereich (z. B. Aufbauservice buchen): Streifen steht wie auf allen anderen
       Seiten vor dem Fuss — dann auch im normalen hellen Kleid. Das PDP-Kleid hat keinen eigenen Grund und
       zeigte dort den dunklen Fuss-Hintergrund (dunkle Schrift auf Dunkelgruen, Handy-Pruefung 01.10.2026). */
    if (b.classList) b.classList.remove('r24mp--pdp');
    if (!footer) footer = document.querySelector('footer');
    if (footer && footer.parentNode) {
      footer.parentNode.insertBefore(b, footer);
    } else {
      var wrap = document.querySelector('.t4s-website-wrapper') || document.querySelector('main') || document.body;
      wrap.appendChild(b);
    }
    b.removeAttribute('hidden');
    b.setAttribute('data-placed', '1');
  }
  if (document.readyState !== 'loading') place(); else document.addEventListener('DOMContentLoaded', place);
  window.addEventListener('load', place);

  /* GARANTIERTER LAUF: Die CSS-Animation ist der Normalfall. Falls sie irgendwo nicht
     greift (fremdes CSS, Theme-Override, gestoppte Animationen), übernimmt nach einer
     Messung ein rAF-Antrieb — der Streifen läuft dann trotzdem. Hover pausiert weiterhin.
     Bei `prefers-reduced-motion` bleibt bewusst alles stehen (dort ist der Streifen
     stattdessen horizontal wischbar). */
  function ensureMotion() {
    var vp = document.querySelector('.r24mp__vp');
    var track = vp && vp.querySelector('.r24mp__track');
    if (!vp || !track || track.getAttribute('data-motion') === '1') return;
    /* Die Marke wurde bisher ERST nach der 700-ms-Messung gesetzt. ensureMotion()
       läuft aber bis zu dreimal (readyState · load · Wiederholung) — zwei Aufrufe
       kamen so beide durch und installierten JE EINE rAF-Schleife, die dann um
       dieselbe transform-Eigenschaft kämpften. Deshalb sofort sperren. */
    if (track.getAttribute('data-motion-check') === '1') return;
    track.setAttribute('data-motion-check', '1');
    var slow = false;
    try { slow = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
    var dur = slow ? 80000 : 34000;

    var a = track.getBoundingClientRect().left;
    setTimeout(function () {
      var b = track.getBoundingClientRect().left;
      if (Math.abs(b - a) > 0.4) { track.setAttribute('data-motion', '1'); return; }  /* CSS läuft bereits */
      var half = track.scrollWidth / 2;
      if (!half) { track.removeAttribute('data-motion-check'); setTimeout(ensureMotion, 600); return; }   /* Layout noch nicht fertig → erneut */
      track.setAttribute('data-motion', '1');
      track.style.animation = 'none';
      var x = 0, paused = false, last = null;
      vp.addEventListener('mouseenter', function () { paused = true; });
      vp.addEventListener('mouseleave', function () { paused = false; });
      vp.addEventListener('focusin', function () { paused = true; });
      vp.addEventListener('focusout', function () { paused = false; });
      /* Ersatz-Antrieb nur, solange der Streifen im Bild und der Tab sichtbar ist —
         vorher lief die rAF-Schleife lebenslang auch offscreen (A16-15). */
      var vis = true, running = false;
      function tick(t) {
        if (!vis || document.hidden) { running = false; last = null; return; }
        if (last === null) last = t;
        var dt = t - last; last = t;
        if (!paused) {
          x -= (half / dur) * dt;
          if (-x >= half) x += half;
          track.style.transform = 'translateX(' + x + 'px)';
        }
        requestAnimationFrame(tick);
      }
      function start() { if (!running && vis && !document.hidden) { running = true; last = null; requestAnimationFrame(tick); } }
      if ('IntersectionObserver' in window) {
        try { new IntersectionObserver(function (es) { vis = es[0].isIntersecting; start(); }).observe(vp); } catch (e) {}
      }
      document.addEventListener('visibilitychange', start);
      start();
    }, 700);
  }
  if (document.readyState !== 'loading') setTimeout(ensureMotion, 400);
  else document.addEventListener('DOMContentLoaded', function () { setTimeout(ensureMotion, 400); });
  window.addEventListener('load', function () { setTimeout(ensureMotion, 400); });
})();
